export default "__VITE_ASSET__fe1aebcd__"